import { GetAllLogPlatformsReq, GetAllLogPlatformsRes, UpdateLogPlatformReq, UpdateLogPlatformRes } from "../interfaces/logPlatform.interface";
import { API } from "./api";



export const getAllLogPlatformService = async (data: GetAllLogPlatformsReq): Promise<GetAllLogPlatformsRes>=>{
    try {
        const res = await API.get(`/v1/log-platform`);
        return res.data;
    } catch (error) {
        throw error
    }
}


export const updateLogPlatformService = async (data: UpdateLogPlatformReq): Promise<UpdateLogPlatformRes>=>{
    try {
        const res = await API.put(`/v1/log-platform`, data);
        return res.data;
    } catch (error) {
        throw error
    }
}